import { Injectable, inject } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';

export interface TouConfig {
  touVersion: string | null;
  touUrl: string | null;
  privacyPolicyUrl: string | null;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private firestore = inject(Firestore);
  private touConfigCache: TouConfig | null = null;

  async getPrivacyPolicyUrl(): Promise<string | null> {
    const snap = await getDoc(doc(this.firestore, 'Config', 'global'));
    if (!snap.exists()) return null;
    return (snap.data()['privacyPolicyUrl'] as string) ?? null;
  }

  invalidateTouConfig(): void {
    this.touConfigCache = null;
  }

  async getTouConfig(): Promise<TouConfig> {
    if (this.touConfigCache) return this.touConfigCache;
    const snap = await getDoc(doc(this.firestore, 'Config', 'global'));
    const data = snap.exists() ? snap.data() : {};
    this.touConfigCache = {
      touVersion: (data['touVersion'] as string) ?? null,
      touUrl: (data['touUrl'] as string) ?? null,
      privacyPolicyUrl: (data['privacyPolicyUrl'] as string) ?? null,
    };
    return this.touConfigCache;
  }
}
